import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Button, Table } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const Standards = () => {
    const dispatch = useDispatch(); 
    const cancelHandler = () => dispatch(resetModel());

    const confirmation = () => {
        cancelHandler();
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } className='standards-model' centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    <div style={{ textAlign: 'center' }}><h2>收費說明</h2></div>
                    {/* <div style={{ textAlign: 'center' }}><span>試營運期間透過APP預約返廠</span></div>
                    <div style={{ textAlign: 'center' }}><p>即享到府取送車  免基本里程費優惠</p></div> */}
                    <ol>
                        <li>此服務須預先安排人力，可取車時段為8:00-12:00，可還車時段為16:00-18:00。我們將盡量配合您所選擇時段，若無法滿足您的需求，懇請見諒。</li>
                        <li>部分服務中心無法提供取送車服務，包含：宜蘭服務中心、花蓮服務中心、苗栗服務中心、南投服務中心、員林服務中心、斗南服務中心、嘉義服務中心、屏東服務中心。</li>
                        <li>因取、還車服務執行當下需上傳車況照片及相關資料存查，取、還車會面地點須有穩定網路訊號，始能續行取送車服務。</li>
                        <li>取車當日請備妥行照隨車</li>
                        <li>系統試算金額僅供參考，實際費用以服務中心計算為準</li>
                        <li>到府取送車為有價服務，收費方式如下 :</li>
                    </ol>
                    <div className="text-block" style={{ marginTop: '40px' }}>
                        <div className="title" style={{ marginBottom: '0px' }}>*里程費：</div>
                        <div><span>基本里程費：10公里內500元</span></div>
                        <div><span>加收里程費：超過10公里，每公里加收55元</span></div>
                        <div><span>未滿1公里以1公里計</span></div>
                    </div>
                    <div className="text-block" style={{ marginTop: '40px' }}>
                        <div className="title" style={{ marginBottom: '0px' }}>*待時費：</div>
                        <div><span>代駕待時費：</span></div>
                        <div><span>預約時間起算，顧客遲到未滿10分鐘不收費，滿10分鐘加收55元，之後每2分鐘加收10元 ，至多收155元。若顧客遲到超過30分鐘最後取消，僅收空趟費。</span></div>
                        <div style={{ marginTop: '20px' }}><span>客戶待時費：</span></div>
                        <div><span>代駕若未於顧客或服務中心預約時間抵達，10分鐘內為緩衝期，若代駕遲到滿10分鐘至30分鐘內，本次服務抵扣100元，顧客若等候時間超過30分鐘，本次取送車服務不收費外，下次您再預約到府取送車服務，將免收基本里程費。</span></div>
                    </div>
                    <div className="table-container">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>等待時間(分)</th>
                                    <th>10</th>
                                    <th>11</th>
                                    <th>12</th>
                                    <th>13</th>
                                    <th>14</th>
                                    <th>15</th>
                                    <th>16</th>
                                    <th>17</th>
                                    <th>18</th>
                                    <th>19</th>
                                    <th>20</th>
                                    <th>21</th>
                                    <th>22</th>
                                    <th>23</th>
                                    <th>24</th>
                                    <th>25</th>
                                    <th>26</th>
                                    <th>27</th>
                                    <th>28</th>
                                    <th>29</th>
                                    <th>30</th>
                                    {/* <th>30~</th>
                                    <th>失約</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>代駕待時費</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>65</td>
                                    <td>65</td>
                                    <td>75</td>
                                    <td>75</td>
                                    <td>85</td>
                                    <td>85</td>
                                    <td>95</td>
                                    <td>95</td>
                                    <td>105</td>
                                    <td>105</td>
                                    <td>115</td>
                                    <td>115</td>
                                    <td>125</td>
                                    <td>125</td>
                                    <td>135</td>
                                    <td>135</td>
                                    <td>145</td>
                                    <td>145</td>
                                    <td>155</td>
                                    {/* <td>司機離開，以失約計</td>
                                    <td>里程費用5折</td> */}
                                </tr>
                                <tr>
                                    <td>客戶待時費</td>
                                    <td colSpan={ 21 }>本次服務抵扣100元</td>
                                    {/* <td>
                                        <span>本次取車服務不收費外</span>
                                        <span>下次免收里程基本費</span>
                                    </td>
                                    <td>-</td> */}
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    <div className="text-block">
                        <p>*空趟費 : 該次里程費用7折</p>
                        <p>*取消預約 : 前一天取消預約可能會有費用產生，實際金額請洽服務中心。</p>
                    </div>
                </div>
                <div className="button-container">
                    <Button type="button" variant="success" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default Standards;